import { render, staticRenderFns } from "./Title.vue?vue&type=template&id=6de7a8e0&scoped=true&"
import script from "./Title.vue?vue&type=script&lang=ts&"
export * from "./Title.vue?vue&type=script&lang=ts&"
import style0 from "./Title.vue?vue&type=style&index=0&id=6de7a8e0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de7a8e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/business/yq-monitor-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6de7a8e0')) {
      api.createRecord('6de7a8e0', component.options)
    } else {
      api.reload('6de7a8e0', component.options)
    }
    module.hot.accept("./Title.vue?vue&type=template&id=6de7a8e0&scoped=true&", function () {
      api.rerender('6de7a8e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/data-view/components/Title.vue"
export default component.exports